export default "__VITE_ASSET__CLaE$5C0__"